<template>
    <div
        class="fixed inset-x-0 bottom-0 transition-all duration-500 ease-in-out zi-60"
        :class="showBanner ? 'translate-y-0' : 'translate-y-full'"
    >
        <div class="mx-auto max-w-7xl px-4 pb-10 sm:pb-4">
            <div class="flex flex-col justify-between rounded-lg bg-gray-900 p-3 shadow-lg gap-y-3">
                <div class="flex items-center justify-between gap-x-3">
                    <div class="flex items-center gap-x-3">
                        <div v-if="icon" class="rounded-lg bg-gray-700 p-2 text-white">
                            <BaseIcon :name="icon.name" :prefix="icon.prefix" size="2x" />
                        </div>
                        <p class="max-w-5xl text-base font-medium text-gray-200" v-html="text" :data-test="dataTest('text')" />
                    </div>
                    <div class="flex items-center gap-x-3">
                        <a
                            :href="buttonLink"
                            :data-test="dataTest('arrow-button')"
                            target="_blank"
                            class="hidden shrink cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-white p-2 text-base font-medium leading-6 text-gray-900 hover:bg-gray-100 hover:text-gray-600 focus:ring-3 focus:outline-hidden sm:flex"
                        >
                            <span class="hidden px-1 md:block">
                                {{ buttonText }}
                            </span>
                            <div class="flex h-6 w-6 items-center justify-center">
                                <BaseIcon name="arrow-right" prefix="fas" size="sm" />
                            </div>
                        </a>
                        <button
                            v-if="closable"
                            class="inline-flex cursor-pointer items-center justify-center rounded-md p-2 text-gray-100 hover:bg-gray-700 focus:bg-gray-700 focus:outline-hidden"
                            :data-test="dataTest('close-button')"
                            @click="close"
                        >
                            <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div v-if="closable && buttonLink" class="w-full sm:hidden">
                    <a
                        class="flex cursor-pointer items-center justify-center rounded-md bg-white px-3 py-2 text-base font-medium leading-6 text-gray-900 gap-x-2 hover:bg-gray-100 focus:ring-3 focus:outline-hidden"
                        target="_blank"
                        :href="buttonLink"
                        :data-test="dataTest('mobile-button')"
                    >
                        <span>
                            {{ buttonText }}
                        </span>
                        <BaseIcon name="arrow-right" prefix="fas" size="sm" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:  'BaseBanner',
    props: {
        show:       Boolean,
        closable:   Boolean,
        icon:       Object,
        text:       String,
        buttonText: String,
        buttonLink: String,
    },
    data() {
        return {
            showBanner: this.show,
        };
    },
    watch:   {
        show(value) {
            this.showBanner = value;
        },
    },
    methods: {
        close() {
            this.showBanner = false;
            this.$emit('close');
        },
    },
};
</script>
